import { render, staticRenderFns } from "./bookSAA.vue?vue&type=template&id=16ab3f37&scoped=true&"
import script from "./bookSAA.vue?vue&type=script&lang=js&"
export * from "./bookSAA.vue?vue&type=script&lang=js&"
import style0 from "./bookSAA.vue?vue&type=style&index=0&id=16ab3f37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ab3f37",
  null
  
)

export default component.exports